/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { RebrandImage } from "../../../shared/common/service/rebrand-image.service";
import { imageAsset } from "../../../shared/common/image-asset/image-asset";

@Injectable({
   providedIn: "root"
})
export class HorizonRebrandImageService extends RebrandImage {
   private imageAsset = imageAsset;
   constructor() {
      super();
   }

   public getHTMLAccessLogo(): string {
      return this.imageAsset.horizonLogo;
   }
}
